import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  Alert,
  Badge,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  Typography,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import { displayLogisticsDate, tmsApi } from './api';

export function ComplianceNotifications() {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const query = useQuery({
    queryKey: ['tms', 'compliance', 'notifications'],
    queryFn: ({ signal }) => tmsApi.notifications(signal),
    refetchInterval: 15 * 60 * 1000,
  });
  const notifications = query.data ?? [];
  return (
    <>
      <IconButton
        aria-label={`${notifications.length} transport compliance notifications`}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        <Badge badgeContent={notifications.length} color="error" max={99}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: { width: 380, maxWidth: '92vw', maxHeight: 480 } } }}
      >
        <Typography variant="subtitle1" fontWeight={700} sx={{ px: 2, py: 1 }}>
          Transport compliance
        </Typography>
        <Divider />
        {query.error ? <Alert severity="error">Unable to load notifications.</Alert> : null}
        {!query.isPending && notifications.length === 0 ? (
          <Typography color="text.secondary" sx={{ px: 2, py: 3 }}>
            No expiries within the alert period.
          </Typography>
        ) : null}
        <List dense disablePadding>
          {notifications.map((notification) => (
            <ListItemButton
              key={notification.id}
              onClick={() => {
                setAnchor(null);
                window.location.assign(notification.path);
              }}
            >
              <ListItemText
                primary={notification.title}
                secondary={`${notification.message} Expiry: ${displayLogisticsDate(notification.expiryDate)}`}
                secondaryTypographyProps={{
                  color: notification.severity === 'error' ? 'error.main' : 'warning.main',
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </Menu>
    </>
  );
}
